import {
  LuSparkles, LuPanelLeft, LuInbox, LuSearch, LuCirclePlus, LuCircleHelp,
} from 'react-icons/lu';
import { defineTour, step } from './defineTour';

const ID = 'welcome';

// On phones the sidebar is an off-canvas drawer: open it for the steps that
// point into it, and close it again when moving on.
const setMobileSidebar = (open) => ({ isMobile }) => {
  if (isMobile) window.dispatchEvent(new CustomEvent('toggle-sidebar', { detail: { open } }));
};
const inSidebar = { beforeShow: setMobileSidebar(true), onLeave: setMobileSidebar(false) };

const welcomeTour = defineTour({
  id: ID,
  scope: '/dashboard',
  exact: true,
  steps: [
    step(ID, 'intro', null, LuSparkles, { variant: 'intro', route: '/dashboard' }),
    step(ID, 'sidebar', 'sidebar', LuPanelLeft, { placement: 'right', route: '/dashboard', padding: 0, ...inSidebar }),
    step(ID, 'inbox', 'nav.inbox', LuInbox, { placement: 'right', optional: true, ...inSidebar }),
    step(ID, 'search', 'header.search', LuSearch),
    step(ID, 'create', 'header.create', LuCirclePlus),
    step(ID, 'help', 'header.help', LuCircleHelp),
  ],
});

export default welcomeTour;
